import React from 'react';
import PropTypes from 'prop-types';
// material-ui components
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';

export const DocumentScoringDimensionPeriodItemComponent = ({
  onPeriodDimensionChange,
  document,
  validationInfo,
  disabled,
  dimensions
}) => {
  const handlePropertyChange = prop => value => {
    switch (prop) {
      case 'selected': {
        onPeriodDimensionChange(prop, value.target.checked);
        break;
      }
      case 'dimensionPeriodYear':
      case 'dimensionPeriodMonth': {
        onPeriodDimensionChange(prop, value);
        break;
      }
      case 'dimensionId': {
        onPeriodDimensionChange(prop, value);
        break;
      }
      default:
        break;
    }
  };

  return (
    <TableRow>
      <TableCell style={{ width: '10%' }}>
        <Checkbox checked={document.selected} onChange={handlePropertyChange('selected')} />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          value={document.dimensionPeriodYear || ''}
          error={validationInfo.dimensionPeriodYear ? true : false}
          onChange={handlePropertyChange('dimensionPeriodYear')}
          disabled={disabled}
        />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          value={document.dimensionPeriodMonth || ''}
          error={validationInfo.dimensionPeriodMonth ? true : false}
          onChange={handlePropertyChange('dimensionPeriodMonth')}
          disabled={disabled}
        />
      </TableCell>
      <TableCell>{document.dimensionPeriodName}</TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          value={document.dimensionId}
          valueKey='id'
          options={dimensions}
          onChange={handlePropertyChange('dimensionId')}
          isClearable={false}
          simpleValue={true}
          name='dimensionId'
        />
      </TableCell>
      <TableCell>{document.dimensionPeriodSourceName}</TableCell>
    </TableRow>
  );
};

DocumentScoringDimensionPeriodItemComponent.propTypes = {
  onPeriodDimensionChange: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
  validationInfo: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  dimensions: PropTypes.array.isRequired
};

export default DocumentScoringDimensionPeriodItemComponent;
